const rewindModule = require('@turf/rewind');

const {
  polygon: geoJsonPolygon
} = require('@turf/helpers'); // Funny story
// Locally yarn-linking admin-sdk causes rewind to be required as `{ default: <rewind> }`
// Running tests causes it to be required as `<rewind>`
// I don't know how to fix it so I'll just handle both.


const rewind = rewindModule.default || rewindModule;

const rewindPolygon = (coordinates
/*: Polygon*/
) =>
/*: Polygon*/
{
  const result = rewind(geoJsonPolygon(coordinates));
  return result.geometry.coordinates;
};

module.exports = rewindPolygon;